import "../styles/components/ContactList.css"

import ContactEntry from "./ContactEntry";
import Header from "./Header";

const ContactList: React.FC = () => {
  return (
   <div className="contactHeader">
    <Header content={""} />
    <div className="contactList">
        <ContactEntry icon={"/icons/location.png"} title="Localização" content="Azinhaga da Fonte do Louro, 16, 1º Esq - 1900-234 Lisboa" link="https://maps.app.goo.gl/ZmTG4a9YHiFSyCBH8" />
        <ContactEntry icon={"/icons/phone.png"} title="Contatos" content="933 137 848" link="tel:933137848" />
        <ContactEntry icon={"/icons/email.png"} title="" content="mnr.psicologiaclinica@gmail.com" link="mailto:mnr.psicologiaclinica@gmail.com" />
        <ContactEntry icon={"/icons/instagram.png"} title="" content="@mnr.psicologiaclinica" link="https://www.instagram.com/mnr.psicologiaclinica?igsh=MXhyMGtpdWg2cTg5bw" />
        <ContactEntry icon={"/icons/linkedin.png"} title="" content="mnr - psicologia clínica" link="https://www.linkedin.com/company/mnr-psicologia-cl%C3%ADnica/posts/?feedView=all" />
    </div>
    </div>
  );
};

export default ContactList;